module.exports = "../fonts/ApercuLAPhil-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./@fonts/apercu-laphil/ApercuLAPhil-Medium.woff
// module id = 508
// module chunks = 7